export const INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_START =
  'INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_START';
export const INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_SUCCESS =
  'INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_SUCCESS';
export const INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_FAILURE =
  'INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_FAILURE';

export const INSTITUTION_COURSES_FETCH_START =
  'INSTITUTION_COURSES_FETCH_START';
export const INSTITUTION_COURSES_FETCH_FAILURE =
  'INSTITUTION_COURSES_FETCH_FAILURE';
export const INSTITUTION_COURSES_FETCH_SUCCESS =
  'INSTITUTION_COURSES_FETCH_SUCCESS';

export const FETCH_INSTITUTION_LINKABLE_COURSES_START =
  'FETCH_INSTITUTION_LINKABLE_COURSES_START';
export const FETCH_INSTITUTION_LINKABLE_COURSES_SUCCESS =
  'FETCH_INSTITUTION_LINKABLE_COURSES_SUCCESS';
export const FETCH_INSTITUTION_LINKABLE_COURSES_FAILURE =
  'FETCH_INSTITUTION_LINKABLE_COURSES_FAILURE';

export const LINK_COURSES_TO_INSTITUTION_SUCCESS =
  'LINK_COURSES_TO_INSTITUTION_SUCCESS';
export const LINK_COURSES_TO_INSTITUTION_FAILURE =
  'LINK_COURSES_TO_INSTITUTION_FAILURE';
export const TOGGLE_COURSE_CHECKBOX = 'TOGGLE_COURSE_CHECKBOX';

export const FETCH_INSTITUTION_LTI_CONSUMER_COURSES_SUCCESS =
  'FETCH_INSTITUTION_LTI_CONSUMER_COURSES_SUCCESS';
export const FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_START =
  'FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_START';
export const FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_SUCCESS =
  'FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_SUCCESS';
export const FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE =
  'FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE';
export const UPDATE_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_SUCCESS =
  'UPDATE_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_SUCCESS';
export const UPDATE_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE =
  'UPDATE_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE';
export const SET_INSTITUTION_LTI_CONSUMER_COHORT_CONTEXT_ID =
  'SET_INSTITUTION_LTI_CONSUMER_COHORT_CONTEXT_ID';
export const FETCH_COURSE_CATEGORY_NAMES = 'FETCH_COURSE_CATEGORY_NAMES';

export const INSTITUTION_ADMIN_UI_REMOVE_COURSE_START =
  'INSTITUTION_ADMIN_UI_REMOVE_COURSE_START';
export const INSTITUTION_ADMIN_UI_REMOVE_COURSE_FAILURE =
  'INSTITUTION_ADMIN_UI_REMOVE_COURSE_FAILURE';
export const INSTITUTION_ADMIN_UI_REMOVE_COURSE_SUCCESS =
  'INSTITUTION_ADMIN_UI_REMOVE_COURSE_SUCCESS';

export const INSTITUTION_ADMIN_UI_COURSES_RESET_ACTION =
  'INSTITUTION_ADMIN_UI_COURSES_RESET_ACTION';

export const INSTITUTION_COURSES_AND_COHORTS_FETCH_START =
  'INSTITUTION_COURSES_AND_COHORTS_FETCH_START';
export const INSTITUTION_COURSES_AND_COHORTS_FETCH_SUCCESS =
  'INSTITUTION_COURSES_AND_COHORTS_FETCH_SUCCESS';
export const INSTITUTION_COURSES_AND_COHORTS_FETCH_FAILURE =
  'INSTITUTION_COURSES_AND_COHORTS_FETCH_FAILURE';

export const TOGGLE_COHORT_CHECKBOX = 'TOGGLE_COHORT_CHECKBOX';

export const INSTITUTION_SEND_INVITATION_START =
  'INSTITUTION_SEND_INVITATION_START';
export const INSTITUTION_SEND_INVITATION_SUCCESS =
  'INSTITUTION_SEND_INVITATION_SUCCESS';
export const INSTITUTION_SEND_INVITATION_FAILURE =
  'INSTITUTION_SEND_INVITATION_FAILURE';
export const INSTITUTION_SEND_INVITATION_FINISH =
  'INSTITUTION_SEND_INVITATION_FINISH';

export const INSTITUTION_INVITE_COURSE_SELECTED =
  'INSTITUTION_INVITE_COURSE_SELECTED';
export const FETCH_INSTITUTION_INVITE_COURSE_SUCCESS =
  'FETCH_INSTITUTION_INVITE_COURSE_SUCCESS';
export const FETCH_INSTITUTION_INVITE_COURSE_FAILURE =
  'FETCH_INSTITUTION_INVITE_COURSE_FAILURE';

export const REMOVE_FROM_SELECTED_COURSES = 'REMOVE_FROM_SELECTED_COURSES';
